'use client';

import { ReactNode } from 'react';

import { List } from '@/components/molecules';
import { cn } from '@/lib/utils/tailwind';

export const Item = ({
  children,
  className,
  prefix,
  suffix,
}: {
  children: ReactNode;
  className?: string;
  prefix: ReactNode;
  suffix: ReactNode;
}) => {
  return (
    <List.Item
      className={cn(
        'flex w-full min-w-0 justify-between items-center py-(--track-list-hspacing-padding-lg) border-b border-b-(--track-list-border-color-default) bg-(--track-list-bg-color-default) hover:bg-(--track-list-bg-color-hover) rounded-none hover:shadow-md transition',
        className,
      )}
      prefix={prefix as string}
      suffix={suffix}
    >
      {children}
    </List.Item>
  );
};
